import { render, staticRenderFns } from "./CustomerInvoicesCreate.vue?vue&type=template&id=3b07378a"
import script from "./CustomerInvoicesCreate.vue?vue&type=script&lang=js"
export * from "./CustomerInvoicesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports